import moment from 'moment-timezone';

export const getUserTimezone = (): string => {
    return moment.tz.guess();
};
